import { useSelector } from 'react-redux';
import { selectColorsSchema } from '../redux/main/uiSlice';

const CustomToggleSwitch = ({ onChange, value }) => {
    // Ottieni i colori dall'account
    const colorsSchema = useSelector(selectColorsSchema) || { primary: '#4CAF50', secondary: '#2196F3' };
    
    // Colori di fallback in caso di problemi
    const defaultActiveColor = '#4CAF50';
    const defaultInactiveColor = '#f5f5f5';
    
    return (
        <div 
            className={`relative h-[26px] border w-10 rounded-full p-1 transition-all duration-300 ease-in-out cursor-pointer`} 
            onClick={() => onChange(!value)}
            style={{
                borderColor: value ? (colorsSchema.primary || defaultActiveColor) : '#ccc',
                backgroundColor: value ? (colorsSchema.primary || defaultActiveColor) : defaultInactiveColor,
                boxShadow: value ? `0 0 2px ${colorsSchema.primary || defaultActiveColor}` : 'none'
            }}
        >
            <div 
                className={`absolute ${value ? 'translate-x-3.5' : 'translate-x-0'} transition-transform duration-300 ease-in-out w-4 h-4 rounded-full`}
                style={{
                    backgroundColor: 'white',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.2)'
                }}
            ></div>
        </div>
    )
}

export default CustomToggleSwitch